var _excluded = ["openingMessage", "errorTitle", "titularElementTag", "signupButtonProps", "primaryLinksProps", "secondaryLinksProps", "data-testid"];
var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/FourTenError/FourTenError.tsx",
  _this = this;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { withWebAssetsTheme } from '../../theme';
import { ClientError } from '../ClientError';
import Links from '../ClientError/Links';
import SignupButton from '../ClientError/SignupButton';
var DEFAULT_COPY = defineMessages({
  // Client Error
  OH_BANANAS: {
    id: 'FourTenError.ohBananas',
    defaultMessage: 'Oh bananas!',
    description: '[Type: Label][Vis.: med] - Oh bananas message'
  },
  TERMS_VIOLATION: {
    id: 'FourTenError.somethingWentWrong',
    defaultMessage: "This survey is currently closed due to a violation of SurveyMonkey's terms of use.",
    description: '[Type: Label][Vis.: med] - terms of use violation title'
  },
  // Primary Links
  HOME: {
    id: 'FourTenError.home',
    defaultMessage: 'SurveyMonkey Home',
    description: '[Type: Label][Vis.: med] - Home link in 410 Error Message'
  },
  SITEMAP: {
    id: 'FourTenError.sitemap',
    defaultMessage: 'Sitemap',
    description: '[Type: Label][Vis.: med] - Sitemap link in 410 Error Message'
  },
  LEARN_MORE: {
    id: 'FourTenError.howItWorks',
    defaultMessage: 'How It Works',
    description: '[Type: Label][Vis.: med] - How It Works link in 410 Error Message'
  },
  // Secondary Links
  TYPES: {
    id: 'FourTenError.types',
    defaultMessage: 'Survey Types',
    description: '[Type: Label][Vis.: med] - Survey Types link in 410 Error Message'
  },
  SATISFACTION_SURVEYS: {
    id: 'FourTenError.satisfactionSurveys',
    defaultMessage: 'Customer Satisfaction Surveys',
    description: '[Type: Label][Vis.: med] - Customer Satisfaction Surveys link in 410 Error Message'
  },
  EMPLOYEE_SURVEYS: {
    id: 'FourTenError.employeeSurveys',
    defaultMessage: 'Employee Surveys',
    description: '[Type: Label][Vis.: med] - Employee Surveys link in 410 Error Message'
  }
});
var defaultPrimaryLinks = {
  links: [{
    label: t(DEFAULT_COPY.HOME),
    href: '/'
  }, {
    label: t(DEFAULT_COPY.SITEMAP),
    href: '/mp/sitemap/'
  }, {
    label: t(DEFAULT_COPY.LEARN_MORE),
    href: '/mp/take-a-tour/'
  }]
};
var defaultSecondaryLinks = {
  links: [{
    label: t(DEFAULT_COPY.TYPES),
    href: '/mp/survey-types/'
  }, {
    label: t(DEFAULT_COPY.SATISFACTION_SURVEYS),
    href: '/mp/customer-satisfaction-surveys/'
  }, {
    label: t(DEFAULT_COPY.EMPLOYEE_SURVEYS),
    href: '/mp/employee-surveys/'
  }]
};
var FourTenError = function FourTenError(_ref) {
  var _ref$openingMessage = _ref.openingMessage,
    openingMessage = _ref$openingMessage === void 0 ? t(DEFAULT_COPY.OH_BANANAS) : _ref$openingMessage,
    _ref$errorTitle = _ref.errorTitle,
    errorTitle = _ref$errorTitle === void 0 ? t(DEFAULT_COPY.TERMS_VIOLATION) : _ref$errorTitle,
    _ref$titularElementTa = _ref.titularElementTag,
    titularElementTag = _ref$titularElementTa === void 0 ? 'p' : _ref$titularElementTa,
    signupButtonProps = _ref.signupButtonProps,
    _ref$primaryLinksProp = _ref.primaryLinksProps,
    primaryLinksProps = _ref$primaryLinksProp === void 0 ? defaultPrimaryLinks : _ref$primaryLinksProp,
    _ref$secondaryLinksPr = _ref.secondaryLinksProps,
    secondaryLinksProps = _ref$secondaryLinksPr === void 0 ? defaultSecondaryLinks : _ref$secondaryLinksPr,
    _ref$dataTestid = _ref['data-testid'],
    dataTestId = _ref$dataTestid === void 0 ? 'FourTenError' : _ref$dataTestid,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ClientError, Object.assign({
    openingMessage: openingMessage,
    errorTitle: errorTitle,
    titularElementTag: titularElementTag,
    "data-testid": dataTestId
  }, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(SignupButton, Object.assign({}, signupButtonProps, {
    mt: 5,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(Links, Object.assign({}, primaryLinksProps, {
    mt: 6,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(Links, Object.assign({}, secondaryLinksProps, {
    mt: 6,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 121,
      columnNumber: 7
    }
  })));
};
export default withWebAssetsTheme(FourTenError);
//# sourceMappingURL=FourTenError.js.map